import {
  Card,
  createTheme,
  Group,
  InputLabel,
  List,
  Stack,
} from "@mantine/core";

export const SpacingTheme = createTheme({
  spacing: {
    s1: "4px",

    xs: "8px",
    s2: "8px",

    sm: "12px",
    s3: "12px",

    md: "16px",
    s4: "16px",

    lg: "20px",
    s5: "20px",

    xl: "24px",
    s6: "24px",

    s8: "32px",
    s10: "40px",
    s12: "48px",
    s16: "64px",
    s20: "80px",
  },
  components: {
    Card: Card.extend({
      defaultProps: {
        p: "s6",
      },
    }),
    Group: Group.extend({
      defaultProps: {
        gap: "s4",
      },
    }),
    Stack: Stack.extend({
      defaultProps: {
        gap: "s4",
      },
    }),
    List: List.extend({
      defaultProps: {
        spacing: "s2",
      },
    }),
    InputLabel: InputLabel.extend({
      defaultProps: {
        mb: "s2",
        c: "ink.6",
      },
    }),
  },
});
